import { useActiveBoxCollections } from './useActiveBoxCollections'

export const useContactAddresses = () => {
  const { data: boxCollections } = useActiveBoxCollections()

  const activeBoxCollectionContractAddress = [...(boxCollections ?? [])].sort(
    (a, b) => a.version - b.version,
  )[0]?.address

  return {
    activeBoxCollectionContractAddress,
  }
}
